import TextField from "./TextField";
import emailRegex from "../emailRegex";

const EmailInput = ({ form: { control }, required, placeholder, ...props }) => (
  <TextField
    control={control}
    name="email"
    label={placeholder ? "" : "Email"}
    placeholder={placeholder}
    variant="outlined"
    rules={{ required, pattern: { value: emailRegex } }}
    {...props}
  />
);

export default EmailInput;
